/// <reference types="pixi.js" />

namespace pixi_tilemap {

    (PIXI as any).tilemap = pixi_tilemap;

}
